const MEDIA_ITEMS = [
  {
    title: '《星际穿越》深度解析：穿越维度的爱与时间',
    desc: '诺兰科幻神作的终极解读，黑洞、五维空间与父女情',
    img: 'https://readdy.ai/api/search-image?query=deep%20space%20scene%20with%20massive%20black%20hole%20and%20distant%20stars%2C%20cinematic%20sci%20fi%20aesthetic%2C%20dark%20cosmic%20background%2C%20warm%20golden%20accretion%20disk%20glow%2C%20atmospheric%2C%20no%20text%20or%20logos&width=800&height=450&seq=media-interstellar-01&orientation=landscape',
    duration: '18:35',
    views: '128万',
  },
  {
    title: '动作电影中的十大经典打斗场面',
    desc: '从叶问到John Wick，盘点那些令人窒息的战斗名场面',
    img: 'https://readdy.ai/api/search-image?query=dynamic%20martial%20arts%20fight%20scene%20silhouette%20with%20dramatic%20backlighting%2C%20atmospheric%20dust%20particles%2C%20cinematic%20lighting%2C%20warm%20golden%20and%20dark%20contrast%2C%20intense%20motion%2C%20no%20text%20or%20logos&width=800&height=450&seq=media-action-02&orientation=landscape',
    duration: '22:10',
    views: '96万',
  },
  {
    title: '2026年最值得期待的十部国产电影',
    desc: '流浪地球3、封神第二部领衔，国产电影迎来爆发之年',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20cinematic%20epic%20landscape%20with%20ancient%20architecture%20and%20dramatic%20sky%2C%20golden%20hour%20lighting%2C%20cinematic%20composition%2C%20rich%20warm%20tones%2C%20atmospheric%20haze%2C%20no%20text%20or%20logos&width=800&height=450&seq=media-chinafilm-03&orientation=landscape',
    duration: '15:42',
    views: '156万',
  },
  {
    title: '恐怖电影推荐：胆小慎入的高分惊悚片',
    desc: '从温子仁到阿里·艾斯特，精选10部真正吓人的恐怖佳作',
    img: 'https://readdy.ai/api/search-image?query=dark%20eerie%20corridor%20with%20a%20single%20dim%20light%20at%20the%20end%2C%20atmospheric%20fog%2C%20cinematic%20horror%20aesthetic%2C%20deep%20shadows%2C%20warm%20amber%20light%20accent%2C%20mysterious%20mood%2C%20no%20text%20or%20logos&width=800&height=450&seq=media-horror-04&orientation=landscape',
    duration: '20:08',
    views: '73万',
  },
  {
    title: '动画电影的幕后制作：从分镜到成片',
    desc: '走进皮克斯与吉卜力的创作世界，揭秘动画制作全过程',
    img: 'https://readdy.ai/api/search-image?query=artistic%20animation%20storyboard%20workspace%20with%20warm%20desk%20lamp%20lighting%2C%20sketches%20and%20drawings%20scattered%2C%20creative%20studio%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20golden%20amber%20tones%2C%20no%20text%20or%20logos&width=800&height=450&seq=media-animation-05&orientation=landscape',
    duration: '25:30',
    views: '62万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            影音推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选影视解说与深度影评，换个角度看电影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group block bg-background-200/40 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              {/* Thumbnail with play overlay */}
              <div className="relative aspect-[16/9] overflow-hidden bg-background-300/30">
                <img
                  src={item.img}
                  alt={`五姑娘影院${item.title}`}
                  title={`五姑娘影院${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-200/70 to-transparent"></div>
                {/* Play button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-950 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                {/* Duration badge */}
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/70 text-foreground-200 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </span>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}